import * as React from 'react';
require('./style.css');

interface IProps {
	rows?: number;
	placeholder?: string;
	value?: string;
	onChangeAction?: any;
}

/**
 *
 * @param props
 */
export const PortalTextArea = (props: IProps) => {
	return (
		<textarea
			placeholder={props.placeholder}
			rows={props.rows}
			className="portalTextarea"
			onChange={(e) => {
				if (props.onChangeAction) {
					props.onChangeAction(e);
				}
			}}
			value={props.value}
		/>
	);
};
